import React from 'react';
import { useMediaQueries, useStrapiImageFormat } from '@hooks';
import { ImageList, ImageListItem } from '@mui/material';
import { LazyImage } from '@components';
import { motion } from 'motion/react';

const QuiltedList = ({ gallery }) => {
  const { isMobile } = useMediaQueries();
  const pattern =
    gallery?.length > 3
      ? [
          { rows: 2, cols: 2 }, // items at index % 5 === 0
          { rows: 2, cols: 1 }, // items at index % 5 === 1
          { rows: 1, cols: 2 }, // items at index % 5 === 2
          { rows: 3, cols: 2 }, // items at index % 5 === 3
          { rows: 2, cols: 1 }, // items at index % 5 === 4
          { rows: 2, cols: 2 }, // items at index % 5 === 5
          { rows: 2, cols: 2 }, // items at index % 5 === 0
          { rows: 2, cols: 1 }, // items at index % 5 === 1
          { rows: 1, cols: 2 }, // items at index % 5 === 2
          { rows: 3, cols: 2 }, // items at index % 5 === 3
          { rows: 2, cols: 1 }, // items at index % 5 === 4
          { rows: 2, cols: 2 }, // items at index % 5 === 5
        ]
      : [
          { rows: 2, cols: 2 }, // items at index % 5 === 0
          { rows: 2, cols: 1 }, // items at index % 5 === 1
          { rows: 2, cols: 2 },
        ];
  const patternMobile = [
    { rows: 3, cols: 2 }, // items at index % 5 === 0
    { rows: 2, cols: 1 }, // items at index % 5 === 1
    { rows: 2, cols: 1 }, // items at index % 5 === 2
    { rows: 3, cols: 2 }, // items at index % 5 === 3
    { rows: 2, cols: 1 }, // items at index % 5 === 4
    { rows: 2, cols: 1 }, // items at index % 5 === 5
    { rows: 3, cols: 2 }, // items at index % 5 === 0
    { rows: 2, cols: 1 }, // items at index % 5 === 1
    { rows: 2, cols: 1 }, // items at index % 5 === 2
    { rows: 3, cols: 2 }, // items at index % 5 === 3
    { rows: 2, cols: 1 }, // items at index % 5 === 4
    { rows: 2, cols: 1 },
  ];

  return (
    <ImageList
      variant="quilted"
      cols={isMobile ? 2 : 5}
      className="w-full h-full overflow-hidden"
      rowHeight={isMobile ? 90 : 200}
    >
      {gallery.map((item, index) => {
        const { attributes } = item;
        const patternIndex = index % pattern.length;
        const { rows, cols } = isMobile
          ? patternMobile[patternIndex]
          : pattern[patternIndex];

        return (
          <ImageListItem key={item.id} cols={cols} rows={rows}>
            <motion.div
              initial={{ opacity: 0.2 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 1.5 }}
              className="w-full h-full"
            >
              <LazyImage
                img={useStrapiImageFormat({ img: attributes })}
                className="object-cover relative h-full w-full"
              />
            </motion.div>
          </ImageListItem>
        );
      })}
    </ImageList>
  );
};

export default QuiltedList;
